export enum ETipoDado {
  String = 1,
  Number = 2,
  Boolean = 3,
  Date = 4
}

export enum EValidacaoNomeada {
  Cnpj = "cnpj",
  Cpf = "cpf",
  Email = "email",
  Url = "url",
  HttpsUrl = "httpsUrl",
  Telefone = "telefone",
  Digits = "digits"
}

export enum EMascaraNomeada {
  Cnpj = "cnpj",
  Cpf = "cpf",
  Cep = "cep",
  Telefone = "telefone",
  Percentage = "percentage"
}

export enum ETipoVisualizacao {
  TEXT = 0,
  NUMBER = 1,
  DATE = 2,
  CHECKBOX = 3,
  SELECT = 4,
  BUTTON = 5,
  UPLOAD = 6,
  DIVIDER = 7,
  BANNER = 8,
  PASSWORD = 9,
  SELECT_MULTIPLE = 10,
  INPUT_TAG_NUMBER = 11,
  INPUT_TAG_TEXT = 12,
  TEXT_AREA = 13,
  RADIO = 14,
  REMOTE_COLLECTION = 15,
  INFO_TEXT = 16,
  CHECKBOX_GROUP = 17
}

export const VISUALIZATION_TYPE_BY_NAME: Record<string, ETipoVisualizacao> = {
  Texto: ETipoVisualizacao.TEXT,
  Numero: ETipoVisualizacao.NUMBER,
  Número: ETipoVisualizacao.NUMBER,
  Data: ETipoVisualizacao.DATE,
  Checkbox: ETipoVisualizacao.CHECKBOX,
  Select: ETipoVisualizacao.SELECT,
  Botao: ETipoVisualizacao.BUTTON,
  Botão: ETipoVisualizacao.BUTTON,
  Upload: ETipoVisualizacao.UPLOAD,
  Divisor: ETipoVisualizacao.DIVIDER,
  Banner: ETipoVisualizacao.BANNER,
  Senha: ETipoVisualizacao.PASSWORD,
  SelectMultiple: ETipoVisualizacao.SELECT_MULTIPLE,
  InputTagNumber: ETipoVisualizacao.INPUT_TAG_NUMBER,
  InputTagText: ETipoVisualizacao.INPUT_TAG_TEXT,
  TextArea: ETipoVisualizacao.TEXT_AREA,
  Radio: ETipoVisualizacao.RADIO,
  RemoteCollection: ETipoVisualizacao.REMOTE_COLLECTION,
  InfoText: ETipoVisualizacao.INFO_TEXT,
  CheckboxGroup: ETipoVisualizacao.CHECKBOX_GROUP
};

export enum EFieldSize {
  Small = "Small",
  Medium = "Medium",
  Large = "Large"
}

export enum EStatusDescriptionField {
  LegacyProperty = "StatusDescription",
  StoneFieldId = "stone-padrao-f360-status"
}

export const FIELD_SIZE_SPAN: Record<string, number> = {
  [EFieldSize.Small]: 8,
  [EFieldSize.Medium]: 12,
  [EFieldSize.Large]: 24
};
